<template>
  <div class="partner-ship section">
    <h1 class="partner-ship-title">PARTNERSHIP</h1>
    <homePartnerVue :showTitle="false" :showName="true" />
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import homePartnerVue from "../home/components/home-partner.vue";
export default defineComponent({
  name: "Partnership",
  components: {
    homePartnerVue,
  },
  setup() {},
});
</script>
<style lang="scss" scoped>
.partner-ship {
  min-height: 650px;
  .partner-ship-title {
    margin: 149px 0 100px;
    text-align: center;
    height: 30px;
    font-size: 22px;
    font-weight: 600;
    color: #231916;
    line-height: 30px;
  }
}
</style>
